import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiIconModule } from '@cigna/ui/icon';
import { UiButtonModule } from '@cigna/ui/button';

import { CollapsibleBlockComponent } from './collapsible-block/collapsible-block.component';
import { CollapsibleGroupComponent } from './collapsible-group/collapsible-group.component';
import { CollapsibleItemComponent } from './collapsible-item/collapsible-item.component';
import { CollapsibleComponent } from './collapsible/collapsible.component';

const declarations = [
  CollapsibleBlockComponent,
  CollapsibleGroupComponent,
  CollapsibleItemComponent,
  CollapsibleComponent,
];

@NgModule({
  declarations,
  imports: [CommonModule, UiIconModule, UiButtonModule],
  exports: declarations,
})
export class UiCollapsibleModule {}
